module.exports = __webpack_public_path__ + "img/59.21440b8c.jpg";